import {
  getMemberDiscountVouchers,
  MemberDiscountVouchers,
} from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export default function useGetMemberDiscountVouchers(status?: string) {
  const controller = new AbortController();

  const { data, isPending, isLoading, isError, error } = useQuery({
    queryKey: ["getMemberDiscountVouchers", status],
    queryFn: async () => {
      const responseData = await getMemberDiscountVouchers({
        signal: controller.signal,
      });
      return responseData as MemberDiscountVouchers | null;
    },
  });

  return {
    memberDiscountVouchers: data || null,
    memberDiscountVouchersFetchError: Boolean(error) || isError,
    isMemberDiscountVouchersLoading: isPending || isLoading,
  };
}
